import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AutoFixHighRoundedIcon from "@mui/icons-material/AutoFixHighRounded";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import CodeOffRoundedIcon from "@mui/icons-material/CodeOffRounded";
import DashboardCustomizeRoundedIcon from "@mui/icons-material/DashboardCustomizeRounded";

const items = [
  {
    icon: <CodeOffRoundedIcon />,
    title: "High Quality Code",
    description:
      "Our Code is meticulously crafted, adhering to best practices, ensuring reliability, scalability, and maintainability.",
  },
  {
    icon: <AutoFixHighRoundedIcon />,
    title: "Innovative functionality",
    description:
      "Remain at the forefront with innovative features that redefine excellence, surpassing competitors and catering to your dynamic requirements.",
  },
  {
    icon: <SettingsSuggestRoundedIcon />,
    title: "Adaptable performance",
    description:
      "Our product seamlessly adapts to your requirements, enhancing productivity and streamlining tasks.",
  },

  {
    icon: <ConstructionRoundedIcon />,
    title: "Quality & Reliability",
    description:
      "Experience unparalleled durability, surpassing expectations, ensuring a lasting investment.",
  },
  {
    icon: <ThumbUpAltRoundedIcon />,
    title: "User-centric Design",
    description:
      "Incorporate our product seamlessly into your daily workflow with an intuitive and user-friendly interface.",
  },

  {
    icon: <DashboardCustomizeRoundedIcon />,
    title: "Maintenance support",
    description:
      "Rely on our maintenance and support services to ensure the smooth operation, security, and continuous improvement of software applications.",
  },
];

export const Highlights = () => {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 10 },
        color: "white",
        bgcolor: "#06090a",
      }}
    >
      <Container
        data-aos="fade-up"
        data-aos-duration="2000"
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: "100%", md: "60%" },
            textAlign: { sm: "left", md: "center" },
          }}
        >
          <Typography component="h2" variant="h4" fontWeight="bold">
            Highlights
          </Typography>
          <Typography variant="body1" sx={{ color: "grey.400" }}>
            Explore the exceptional qualities of our product: adaptability,
            longevity, intuitive design, and groundbreaking innovation.
            Experience reliable customer support and attention to detail.
          </Typography>
        </Box>
        <Grid container spacing={2.5}>
          {items.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Stack
                direction="column"
                color="inherit"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  p: 3,
                  height: "100%",
                  border: "1px solid",
                  borderColor: "grey.800",
                  background: "transparent",
                  backgroundColor: "grey.900",
                }}
              >
                <Box sx={{ opacity: "50%" }}>{item.icon}</Box>
                <div>
                  <Typography fontWeight="medium" gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "grey.400" }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
